"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useGameBridge_1 = require("./useGameBridge");
function useSubscribeData(channel, id) {
    const gameBridge = (0, useGameBridge_1.default)();
    const [data, setData] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        gameBridge.subscribe(channel, id, setData);
    }, [channel, id]);
    return data;
}
exports.default = useSubscribeData;
